const colors = {
    black: "#26292D",
    semiBlack: "#383C42"
}

export default colors;